import { type AttributeType } from './endpoint_metadata'
import { displayAttribute } from './display'

interface ConditionsElements {
  containers: HTMLElement[]
  attributeSelects: HTMLSelectElement[]
  valueInputs: HTMLInputElement[]
  valueTypeInputs: HTMLInputElement[]
}

export class ConditionsSection {
  constructor (private readonly el: ConditionsElements) {}

  updateAll (node: string, attributes: AttributeType[]): void {
    this.el.attributeSelects.forEach(select => {
      this.updateOptions(select, node, attributes)
    })
  }

  updateOptions (select: HTMLSelectElement, node: string, attributes: AttributeType[]): void {
    const initial = select.dataset.initialAttributeValue

    select.replaceChildren()

    for (const attr of attributes) {
      const option = new Option(displayAttribute(node, attr.path), attr.path)
      option.dataset.type = attr.type
      select.add(option)
    }

    const hasInitial =
      typeof initial === 'string' &&
      initial.length > 0 &&
      attributes.some(a => a.path === initial)

    select.value = hasInitial ? initial : (attributes[0]?.path ?? '')
    this.syncValueType(select)
  }

  syncValueType (select: HTMLSelectElement): void {
    const option = select.selectedOptions[0]
    const fieldType = option?.dataset.type
    if (fieldType == null) return

    const container = this.el.containers.find(c => c.contains(select))
    if (container == null) return

    const typeInput = this.el.valueTypeInputs.find(input => container.contains(input))
    if (typeInput != null) {
      typeInput.value = fieldType
    }

    const inputs = this.el.valueInputs.filter(input => container.contains(input))

    this.toggleInputField(inputs, fieldType === 'integer' ? 'number' : fieldType)
  }

  clearValues (): void {
    this.el.valueInputs.forEach(input => {
      input.value = ''
    })

    this.el.valueTypeInputs.forEach(input => {
      input.value = ''
    })
  }

  removeNonPersisted (): void {
    this.el.containers.forEach(condition => {
      condition.dispatchEvent(new CustomEvent('removable:remove', { bubbles: true }))
    })
  }

  private toggleInputField (inputs: HTMLInputElement[], typeToEnable: string | null): void {
    inputs.forEach(input => {
      const inputType = input.dataset.type
      if (inputType === typeToEnable) {
        input.classList.remove('hidden')
        input.disabled = false
      } else {
        input.classList.add('hidden')
        input.disabled = true
        input.value = ''
      }
    })
  }
}
